import DecompositionController from './syntheseentities.decompo.controller';

export default {
    controller: DecompositionController,
    template: require('./syntheseentities.decompo.html')
};
